import { Helmet } from 'react-helmet-async';

import PassResetForm from '../components/passResetForm';
import { DOMAIN_NAME } from '../config/api';

const PassResetPage = () => {

  return (
    <div className="reset p-4">
      <Helmet>
        <title>Восстановление пароля |{DOMAIN_NAME}</title>
      </Helmet>
      <PassResetForm />
    </div>
  )
};
export default PassResetPage;
